import { render } from "./FactoriesTable.vue?vue&type=template&id=9c14b2b0"
import script from "./FactoriesTable.vue?vue&type=script&lang=js"
export * from "./FactoriesTable.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./FactoriesTable.vue?vue&type=style&index=0&id=9c14b2b0&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script